// extracted by mini-css-extract-plugin
export var brandContainer = "footer-module--brand-container--b4e41";
export var copyright = "footer-module--copyright--dbfde";
export var footerContainer = "footer-module--footer-container--88d6f";
export var globalfooter = "footer-module--globalfooter--717ec";
export var logo = "footer-module--logo--b00e1";
export var sitemapContainer = "footer-module--sitemap-container--57e71";
export var sitemapList = "footer-module--sitemap-list--2c00f";
export var snsList = "footer-module--sns-list--49a82";